import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function AgencyRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-[#071129] text-white/70">Carregando...</div>;
  if (!user) return <Navigate to="/auth/login" replace />;
  // Master admin com agency_id vinculada pode acessar o painel da imobiliária
  // pra demonstrações (mesmo tendo role=admin).
  const canAccess = user.role === "agency_admin" ||
    (user.role === "admin" && user.agency_id);
  if (!canAccess) return <Navigate to="/app" replace />;
  return children;
}
